<template>
  <v-dialog v-model="showModal" width="500" persistent scrollable>
      <v-card>
        <v-card-title class="headline">Create Question</v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form @submit.prevent="saveQuestion">
            <v-text-field
              v-model="title"
              :counter="500"
              label="Title"
              v-validate="'required|max:500'"
              :error-messages="errors.collect('title')"
              data-vv-name="title"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" @click="closeModalQuestion">Close</v-btn>
          <v-btn color="primary" @click="saveQuestion">Save</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
</template>
<script>
import { mapActions } from 'vuex';

export default {
  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },
  data () {
    
    return {
      title: '',
      type: 'PERSONAL',
      itemList: ''
    };
  },
  computed: {
    previewList: function () {
      let list = [];
      list = this.itemList.split(',');
      this.options = list;
      return list;  
    },
  },
  methods: {
    ...mapActions(['setSnackbar', 'setLoading']),
    saveQuestion () {
      this.$validator.validateAll().then(result => {
        if (result) {
          let payload = {
            title: this.title,
            type: this.type,
          };
          this.setLoading(true);
          const url = '/questions/personal-question';
          window.axios.post(url, payload).then((response) => {
            this.setLoading(false);
            this.$emit('add-personal-question', response.data.data);
            this.closeModalQuestion();
            this.resetForm();
          }).catch((error) => {
            this.$store.dispatch('setLoading', false);
          });
        } else {
          this.setSnackbar({
            show: true,
            color: 'info',
            text: 'Check the form, please.'
          });
        }

      });     
    },
    closeModalQuestion () {
      this.$emit('close-modal-create');
      this.options = [];
    },
    resetForm () {
      this.title = '';
      this.type = 'TEXT';
      this.itemList = '';
    }
  }
};
</script>
<style>
  .text-right{
    text-align: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/client/questions/modals/CreatePersonalQuestion.vue